$(function () {
  $('.js-field').on('keyup', function(event) {
    $(this).toggleClass('has-value', $(this).val() !== '');
  });

  $('.js-show-password').on('click', function(event) {
    event.preventDefault();

    const $this = $(this);
    const $field = $this.parent().find('.js-field');

    $this.find('i').toggleClass('is-hidden');
    $field.attr('type', $field.attr('type') === 'text' ? 'password' : 'text');
  });
});
